module.exports = __webpack_public_path__ + "img/woman_holding_fb.0f43b5ae.svg";